/** 管理后台 CSRF：与服务器 admin-csrf 约定一致 */
export const ADMIN_CSRF_HEADER = 'X-CKM-Admin-CSRF'
export const ADMIN_CSRF_VALUE = '1'

export function adminCsrfHeaders () {
  return { [ADMIN_CSRF_HEADER]: ADMIN_CSRF_VALUE }
}
